import React from 'react';
import { Chip } from '@mui/material';

/**
 * 역량평가 플랫폼 사용가능 여부 셀 컴포넌트
 * 
 * 역량평가 플랫폼 사용가능 여부를 Chip으로 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {number} params.row.groupAssessId - 평가ID (있으면 사용 가능)
 */
const DevelopmentCell = ({ row }) => {
  const label = row.aiCodeReviewEnabled ? '사용 가능' : '불가능';
  const color = row.aiCodeReviewEnabled ? 'success' : 'error';
  
  return (
    <Chip
      label={label}
      size="small"
      color={color}
      variant="outlined"
    />
  );
};

export default DevelopmentCell;
